export function ShieldIcon() {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="80"
        cy="80"
        r="80"
        fill="var(--landing-advantages-icon-bg, #E3D5BE)"
        fillOpacity="var(--landing-advantages-icon-bg-opacity, 0.24)"
      />
      <path
        d="M80.3994 22C97.3374 22 112.511 26.5344 120.056 29.2344C126.482 31.5197 130.8 37.6581 130.8 44.4785L130.771 44.4863V85.9785C130.771 95.9129 125.096 102.502 122.361 105.673L121.841 106.284C118.473 110.25 114.606 113.808 105.838 119.391C102.343 121.591 97.7875 124.179 92.2822 127.062C84.9354 130.915 75.8083 130.915 68.4678 127.062C62.9556 124.165 58.3855 121.591 54.9121 119.376C46.095 113.765 42.2625 110.2 38.8945 106.256L38.4443 105.735C35.7092 102.564 30.0001 95.976 30 86.0059V44.499C30.0002 37.7 34.3032 31.562 40.7295 29.2559C48.266 26.5348 63.4616 22.0001 80.3994 22ZM80.3857 29.2266C64.5296 29.2266 50.2566 33.4875 43.1621 36.0469C39.5761 37.3265 37.1855 40.7435 37.1855 44.5264V86.0322C37.1855 93.3234 41.3758 98.161 43.8789 101.044L44.3643 101.6C47.2963 105.038 50.7349 108.202 58.7998 113.335C62.1116 115.444 66.4846 117.926 71.8281 120.718C74.4226 122.068 77.39 122.784 80.3994 122.784C83.4088 122.784 86.3762 122.068 88.9707 120.718C94.2932 117.926 98.6874 115.444 101.999 113.335C110.008 108.237 113.446 105.073 116.399 101.613L116.94 100.98C119.422 98.0838 123.6 93.2605 123.6 85.9902L123.587 86.0176V44.5264C123.587 40.7298 121.175 37.3267 117.61 36.0469C110.515 33.4945 96.2412 29.2266 80.3857 29.2266ZM95.875 59.0615C97.1476 57.7824 99.6852 57.7823 100.965 59.0615C101.647 59.7295 102.026 60.6443 102.026 61.6006C102.026 62.5568 101.647 63.4567 100.965 64.1387L80.5742 84.5293C79.0837 86.0266 77.122 86.835 75.0127 86.835C72.9106 86.8349 70.9276 86.0058 69.4512 84.5293L59.8604 74.9385C59.1786 74.2706 58.7989 73.3705 58.7988 72.4004C58.7988 71.4231 59.1785 70.5228 59.8604 69.8408C60.5283 69.1799 61.4431 68.7998 62.3994 68.7998C63.3557 68.7999 64.2555 69.1803 64.9375 69.8623L74.999 79.9023L95.8613 59.04L95.875 59.0615Z"
        fill="url(#paint0_linear_43_520)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_43_520"
          x1="80.3999"
          y1="21.999"
          x2="80.3999"
          y2="129.951"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--landing-advantages-icon-color-from, #FFA24B)" />
          <stop
            offset="1"
            stopColor="var(--landing-advantages-icon-color-to, #FF7B01)"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
